module.exports = __webpack_public_path__ + "static/NewBaskervilleStd-Italic-5d04a17237a5a0147847030dc5e7775c.woff";